module.exports = __webpack_public_path__ + "static/img/logoIndecx.62594d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoIndecx.png
// module id = /tlN
// module chunks = 1